import { render, staticRenderFns } from "./SharedIcon.vue?vue&type=template&id=65a9e63c&lang=pug"
import script from "./SharedIcon.vue?vue&type=script&lang=js"
export * from "./SharedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports